$('.btn.edit-address').click(function () {
    $(this).hide();
    $(this).parents('td').siblings('.address-edit').show();
    $(this).siblings('.btn.edit-address-cancel').show();
    $(this).siblings('.btn.edit-address-submit').show();
    $(this).siblings('.btn.delete-address').hide();
    $(this).parents('td').siblings('.address-record').hide()
});

$('.btn.edit-address-submit').click(function () {
    $(this).hide();
    $(this).parents('td').siblings('.address-edit').hide();
    $(this).siblings('.btn.edit-address-cancel').hide();
    $(this).siblings('.btn.edit-address').show();
    $(this).siblings('.btn.delete-address').show();
    $(this).parents('td').siblings('.address-record').show()
});

$('.btn.edit-address-cancel').click(function () {
    $(this).hide();
    $(this).parents('td').siblings('.address-edit').hide();
    $(this).siblings('.btn.edit-address-submit').hide();
    $(this).siblings('.btn.edit-address').show();
    $(this).siblings('.btn.delete-address').show();
    $(this).parents('td').siblings('.address-record').show()
});

$('.carousel').carousel()

$('.flavours-carousel-404').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    dots: false,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 470,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$('.flavours-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    nextArrow: '<div class="slick-custom-arrow slick-custom-arrow-right"><i class="fas fa-angle-right"></i></div>',
    prevArrow: '<div class="slick-custom-arrow slick-custom-arrow-left"><i class="fa fa-angle-left"></i></div>',
    dots: true,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 470,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


$('.single-product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    customPaging: function (slider, i) {
        var thumb = $(slider.$slides[i]).find('.slide-thumb-info').data('thumb');
        return `<a><img class="img-fluid" src="${thumb}" /></a>`;
    },
    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 3,
    //       infinite: true,
    //       dots: true
    //     }
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 2
    //     }
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1
    //     }
    //   }
    // ]
});

function getVariantFromOptions() {
    let variantArr = []
    $(".product-category select").map(function (i, el) {
        variant = { value: $(el).val(), index: $(el).data('index') };
        variantArr.push(variant)
    });
    return variantArr;
}

function updateHistoryState(variant) {
    if (!history.replaceState || !variant) {
        return;
    }

    var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;

    window.history.replaceState({ path: newurl }, '', newurl);
}

$('.product-category select').on('change', function () {
    var selectedValues = getVariantFromOptions();
    var variants = window.product.variants;

    // Search for product variants based on what was selected in the dropdowns
    var found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
            return _.isEqual(variant[values.index], values.value);
        });
    });
    updateHistoryState(found)
    $('#variant-id').val(found.id)
});

function sortCollections(collection) {
    if (collection === 'all') {
        $('.collection-sort-item').show();
        // Show all recargas as well
        $('.vy-filter-sub-category li').removeClass('active_sub_li');
        $('.vy-filter-sub-category li[data-title="all"]').addClass('active_sub_li');

        $('.recargas-collection li').show();
        redefineStickerVars();
        return;
    }

    $('.collection-sort-item').hide();
    $('.collection-sort-item.' + collection + '-collection').show();
    redefineStickerVars();
}

$('.vy-category-item').on('click', function () {
    $('.vy-category-item').removeClass('active');
    var collection = $(this).data('collection');
    $(this).addClass('active');
    if (collection === 'recargas') {
        var mobileSize = window.matchMedia("(max-width: 1023px)");
        if (mobileSize.matches) { // If media query matches
            $('.vy-filter-sub-category').toggleClass('hidden');
        } else {
            $('.vy-filter-sub-category').removeClass('hidden');
        }
    } else {
        $('.vy-filter-sub-category').addClass('hidden');
    }
    sortCollections(collection);
});

$('.vy-filter-sub-category li').on('click', function () {
    var value = $(this).data('title');
    $('.vy-filter-sub-category li').removeClass('active_sub_li');
    $(this).addClass('active_sub_li');
    if (value == "all") {
        $('.recargas-collection li').show();
    } else {
        var parents = $('.vy-variant-flavours .vy-variant-option[data-title="' + value + '"]').closest('li');
        $('.recargas-collection li').hide();
        $(parents).show();
    }
});

$(".vy-increment-button").on("click", function () {

    var $button = $(this);
    var $input = $button.parent().find("input");
    var oldValue = $button.parent().find("input").val();
    var maxValue = $button.parent().find("input").data('max');

    if ($button.text() == "+") {
        if (maxValue && oldValue == maxValue) {
            newVal = oldValue
        } else {
            var newVal = parseFloat(oldValue) + 1;
        }
    } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
            var newVal = parseFloat(oldValue) - 1;
        } else {
            newVal = 1;
        }
    }

    $button.parent().find("input").val(newVal);
    $button.parent().find(".vy-increment-label").text(newVal);

    $input.trigger("change");

});

$(".vy-variant-option").on('click', function () {
    var variant = $(this).data('id');
    var slideNo = $(this).data('slide');
    var image = $(this).data('image');
    var $image = $(this).closest('.product-listed-item').find('.plp-product-image');
    $('.vy-product-variant-id').val(variant);
    $image.attr('src', image);
    $(this).parent().find(".vy-variant-option").removeClass('active');
    $('.single-product-images').slick('slickGoTo', slideNo)
    $(this).addClass('active');
})

var sticker = $('#sticker');
var $sticky, $stickyrStopper, generalSidebarHeight, stickyTop, stickOffset, stickyStopperPosition, stopPoint, diff;

function stickify() {
    $sticky = $('.sticky');
    $stickyrStopper = $('.sticky-stopper');
    if (!!$sticky.offset()) { // make sure ".sticky" element exists

        generalSidebarHeight = $sticky.innerHeight();
        stickyTop = $sticky.offset().top;
        stickOffset = 100;
        stickyStopperPosition = $stickyrStopper.offset().top;
        stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
        diff = stopPoint + stickOffset;

    }
}

function redefineStickerVars() {
    var x = window.matchMedia("(min-width: 1024px)");

    if (x.matches) { // If media query matches
        sticker.addClass('sticky');
    } else {
        sticker.removeClass('sticky');
        sticker.css({ position: 'relative', top: 'initial' });
    }

    stickify();
}

$(window).resize(function () {
    redefineStickerVars();
});

$(window).scroll(function () { // scroll event
    var windowTop = $(window).scrollTop(); // returns number
    if (stopPoint < windowTop) {
        $sticky.css({ position: 'absolute', top: diff });
    } else if (stickyTop < windowTop + stickOffset) {
        $sticky.css({ position: 'fixed', top: stickOffset });
    } else {
        $sticky.css({ position: 'absolute', top: 'initial' });
    }
});

$(document).ready(function () {
    console.log("document ready!");

    redefineStickerVars();
});

// Product purchase sticky controls
$(document).ready(function () {

    /* Every time the window is scrolled ... */
    $(window).scroll(function () {

        /* Check the location of each desired element */
        $('.vy-product-info-footer').each(function (i) {

            var bottom_of_object = $(this).offset().top + $(this).outerHeight();

            if ($(window).scrollTop() > bottom_of_object) {

                $('.vy-sticky-purchase').addClass('visible');

            } else {

                $('.vy-sticky-purchase').removeClass('visible');
            }

        });

    });

});

// ACCOUNTS PAGES
$('.vy-forgot-password-link').click(function () {
    $('.vy-accounts-form-wrapper').hide();
    $('.forgotpsw_form').css('display', 'flex');
});
$('.vy-login-link').click(function () {
    $('.vy-accounts-form-wrapper').hide();
    $('.login_form').css('display', 'flex');
});
$('.toggle_accept_terms').on('change', function () {
    validateRegFormSubmit();
});
$('.dob-field').on('change', function () {
    $('.dob-field').removeClass('is-invalid');
    validateRegFormSubmit();
});
$('#PSWConfirmInput').on('blur', function () {
    $(this).removeClass('is-invalid');
    validatePSW();
});

function setLocallyDOB() {

    var year = parseInt($('.dob-field-year').val(), 10);
    var month = parseInt($('.dob-field-month').val(), 10);
    var day = parseInt($('.dob-field-day').val(), 10);
    console.log(year)
    sessionStorage.setItem('yearDOB', year);
    sessionStorage.setItem('monthDOB', month);
    sessionStorage.setItem('dayDOB', day);
}

function getLocallyDOB() {
    var year = sessionStorage.getItem('yearDOB');
    var month = sessionStorage.getItem('monthDOB');
    if (month <= 9) month = '0' + month.toString();
    var day = sessionStorage.getItem('dayDOB');
    if (day <= 9) day = '0' + day.toString();
    if (year) {
        $('.dob-field-year').val(year.toString())
    }
    if (month) {
        $('.dob-field-month').val(month.toString())
    }
    if (day) {
        $('.dob-field-day').val(day.toString())
    }
}

function formatDate(date) {
    var monthNames = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();

    if (day < 10) {
        day = '0' + day;
    }

    if (month < 10) {
        month = '0' + month;
    }

    // return day + ' ' + monthNames[monthIndex] + ' ' + year;
    return day + '-' + month + '-' + year;
}
var curDOB;
function hasValidDOB() {
    var year = parseInt($('.dob-field-year').val(), 10);
    var month = parseInt($('.dob-field-month').val(), 10);
    var day = parseInt($('.dob-field-day').val(), 10);
    if (year && month && day) {
        var age = 18;
        var setDate = new Date(year + age, month - 1, day);
        var dob = new Date(year, month - 1, day);
        if (dob.getFullYear() != year || dob.getMonth() != month - 1 || dob.getDate() != day) {
            $('.dob-field').addClass('is-invalid');
            return false;
        }
        var currdate = new Date();
        if (currdate >= setDate) {
            // you are above 18
            $('.real-dob').val(formatDate(dob));
            curDOB = dob.getTime();
            return true;
        }
    }
    $('.dob-field').addClass('is-invalid');
    return false;
}

function validatePSW() {
    var psw = $('#PSWInput').val();
    var cpsw = $('#PSWConfirmInput').val();
    if (psw === cpsw) {
        return true;
    }
    $('#PSWConfirmInput').addClass('is-invalid');
    return false;
}

function validateRegFormSubmit() {
    var validDOB = hasValidDOB();
    var validPSW = validatePSW();
    if ($('.toggle_accept_terms').is(':checked') && validDOB && validPSW) {
        $('.register_button').removeAttr('disabled');
    } else {
        $('.register_button').attr('disabled', 'disabled');
    }
    return
}

$('.register_button').click(function (e) {
    e.preventDefault();
    if ($(this).is(':disabled')) {
        return false;
    }
    $('#create_customer').submit();
});

// Discount at checkout
$('#DiscountCode').keyup(function () {
    var action = '?discount=' + $(this).val();
    $('.checkout-form').attr('action', action);
});

// Previous Orders masonry layout

function resizeGridItem(item) {
    grid = document.getElementsByClassName("orders_grid")[0];
    rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
    allItems = document.getElementsByClassName("previous-order");
    for (x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance) {
    item = instance.elements[0];
    resizeGridItem(item);
}

window.onload = resizeAllGridItems();

window.addEventListener("resize", resizeAllGridItems);


// FORM MODAL SUPPORT
$('.vy-close-modal').on('click', function () {
    $('.vy-form-modal').hide();
});

$('*[href="#openForm"]').on('click', function () {
    $('.vy-form-modal').show();
});

// SEARCH NAV
$('.open-search').on('click', function () {
    $('.vy-search-nav').show();
});
$('.close-search').on('click', function () {
    $('.vy-search-nav').hide();
});
$('.do-search').on('click', function () {
    $('#vysearch').submit();
});

var checkoutTermsAccepted = false;

// CONFIRM DOB FOR CHECKOUT
// This checkout button should be uncommented once the payment gateway is implemented and ready to be used instead of preorder.
var acceptCheckoutTerms = '<div class="vy-checkout-terms"><div class="checkbox"><label><input type="checkbox" id="accept_checkout_terms" /> He leído y acepto los <a href="/pages/terminos-y-condiciones" target="_blank">Términos y Condiciones</a> de venta y la <a href="/pages/politica-de-privacidad" target="_blank">Política de Privacidad</a>. Asimismo, manifiesto ser mayor de 18 años.</label></div></div>';
var checkoutBtn = '<input class="checkout-btn" id="vy-checkout-btn" disabled type="submit" name="checkout" value="Comprar Ahora">';
$('.confirm-dob').on('click', function () {
    // Verify age
    if (hasValidDOB()) {
        setLocallyDOB();
        $('.checkout-dob-wrapper').hide();
        // Remove this variable when above one is in use
        // var checkoutBtn = '<a class="vy-cta-btn vy-cta-btn-solid-black" style="display:block;" href="/pages/cml_checkout?d=' + curDOB +'">Reserva Ahora</a>';
        $('.checkout-btn-wrapper').html(acceptCheckoutTerms + checkoutBtn);
        $('.vy-checkout-terms').bootstrapMaterialDesign(); // initialise bootstrap on new DOM elements
    } else {
        $('.dob-error').text('No tienes la edad suficiente para realizar una compra en esta tienda.');
    }
});

$(document).ready(function () {
    getLocallyDOB();
});

$(document).on('change', '#accept_checkout_terms', function () {
    if ($(this).is(":checked")) {
        $('#vy-checkout-btn').removeAttr('disabled');
    } else {
        $('#vy-checkout-btn').attr('disabled', true);
    }
});

$(document).on('click', '#vy-checkout-btn', function () {
    if ($(this).attr('disabled')) {
        return false;
    }
    return true;
});


// FOOTER EMAIL SUBSCRIBE
var $emailField = $('#mce-EMAIL');
var $emailConsent = $('#gdpr_32057');
var $emailSubmit = $('#mc-embedded-subscribe');
function validateFooterForm() {
    if ($emailField.val() && $emailConsent.is(':checked')) {
        $emailSubmit.show();
    } else {
        $emailSubmit.hide();
    }
}

// $emailField.on('keyup', function() {
//   validateFooterForm();
// })

// $emailConsent.on('change', function() {
//   validateFooterForm();
// })


// Prevent people from adding more kits to cart
$('.qty_30230291382375, .qty_30230291415143').on('keyup', function () {
    var val = $(this).val();
    if (val > 2) {
        $(this).val("2");
    }
});

$(document).on('change', '.update_qty', function () {
    $('#update-btn, #update-overlay').show();
    var qty = parseInt($(this).val(), 10);
    var parent = $(this).closest('tr');
    var priceTable = $(this).closest('tbody');
    var price = parent.find('.vy_unit_price');
    var priceNum = parseInt(price.data('price'), 10);
    var subtotal = parent.find('.vy_unit_subtotal');
    var new_sub = qty * (priceNum / 100);
    var footTotal = $('.vy-subtotal-footer').find('.total_price');
    var footTotalVal = parseInt(footTotal.data('total'), 10);

    var sub_new_sub = String('€' + new_sub).replace('.', ',');

    // Now calculate the total
    var items = priceTable.find('tr');
    var totalPrice = 0;
    items.each(function (index) {
        var itemQty = parseInt($(this).find('.update_qty').val(), 10);
        var itemPrice = parseInt($(this).find('.vy_unit_price').data('price'), 10);
        totalPrice = totalPrice + ((itemPrice / 100) * itemQty);
    })
    var sub_new_total = String('€' + totalPrice.toFixed(2)).replace('.', ',');

    subtotal.text(sub_new_sub);
    footTotal.text(sub_new_total);
    return;
});

$('.close-vy-modal').on('click', function () {
    $(this).closest('.vy-modal-controller').removeClass('is--visible');
});

// AJAX SUBMIT TO CART
var cartCountBox = $('.cartCountBox');
var cartCount = parseInt($('.cartCountBox').text(), 10);
var toBeAdded = 0;

$('.dyn_add_to_cart_btn').on('click', function (e) {
    e.preventDefault();
    var form = $(this).closest('form');
    addItem(form);
    return false;
});

//open modal and overlay
function openModal() {
    $('.cart-added-modal').fadeIn('fast');
    setTimeout(function () {
        $('.cart-added-modal').fadeOut('fast');
    }, 2000);
}

function addItem(form) {
    toBeAdded = parseInt($(form).find('input[name="quantity"]').val(), 10);
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $(form).serialize(),
        success: addToCartOk,
        error: addToCartFail
    });
}

function addToCartOk(product) {
    cartCount = cartCount + toBeAdded;
    toBeAdded = 0;
    $('.add-cart-message > b').text(product.title);
    cartCountBox.text(cartCount);
    openModal();
}

function addToCartFail(obj, status) {
    console.log('The product you are trying to add is out of stock.');
    console.log(obj);
    console.log(status);
    openModal()
}





//Remove account
//open modal and overlay
function openModalDeleteAccount() {
    $('.userDeleteModal').fadeIn('fast');
    setTimeout(function () {
        $('.userDeleteModal').fadeOut('fast');
    }, 2000);
}

$('.dyn_remove_account_btn').on('click', function (e) {
    e.preventDefault();
    console.log('Account ask for delete');
    var accountID = $(this).closest('form');
    removeItem(accountID);
    return false;
});
function removeItem(accountID) {
    $.ajax({
        type: 'POST',
        url: '/pages/delete-account',
        dataType: 'json',
        data: $(accountID).serialize(),
        success: removeAccountOk,
        error: removeAccountFail
    });
}
function removeAccountOk(product) {
    console.log('The account is delated!');
    openModalDeleteAccount();
    window.location = "/challenge#contact_form";
}
function removeAccountFail(obj, status) {
    //window.location = "/challenge#contact_form";
    console.log('Something wrong to delate account');
    console.log(obj);
    console.log(status);
    openModalDeleteAccount()
}


//Add account
//open modal and overlay
function openModalRegisterAccount() {
    $('.userCreateModal').fadeIn('fast');
    setTimeout(function () {
        $('.userCreateModal').fadeOut('fast');
    }, 2000);
}

$('.dyn_create_account_addpopup').on('click', function (e) {
    e.preventDefault();
    console.log('customer ask for create account');
    var accountID = $(this).closest('form');
    createItem(accountID);
    return false;
});
function createItem(accountID) {
    $.ajax({
        type: 'POST',
        url: '/account/register',
        dataType: 'json',
        data: $(accountID).serialize(),
        success: addAccountOk,
        error: addAccountFail
    });
}
function addAccountOk(product) {
    console.log('The account is created!');
    openModalRegisterAccount()
}
function addAccountFail(obj, status) {
    console.log('Something wrong to create account');
    console.log(obj);
    console.log(status);
    openModalRegisterAccount()
}












// Updates to Store Locator styling
var loaded = false;
$(document).ajaxComplete(function (event, xhr, settings) {
    // Let's only execute this command once the items have been listed
    if (!loaded) {
        console.log('store locator is loaded');
        $('.gbStore-search-button').addClass('vy-cta-btn');
        $('.gbStore-search-button').find('.gbStore-filter-option-label').text('Buscar');
        $('.gbStore-search-field ').removeClass('gbStore-search-field');
        $('#gbStore-search-text').wrap('<div class="form-group"></div>');
        $('#gbStore-search-text').removeAttr('placeholder');
        $('#gbStore-search-text').addClass('form-control');
        $('#gbStore-search-text').after('<label for="gbStore-search-text" class="bmd-label-floating">Buscar una tienda <small>(ciudad, calle, código postal…)</small></label>');
        $('#gbStore-search-text').on('focus', function () {
            $('.near-me-pin').removeClass('is--active');
        })

        $('#gbStore-panel').prepend('<h1>Localizador de tiendas</h1>');

        var nearme = $('<div class="near-me-pin"></div>');
        nearme.append('<i class="material-icons">my_location</i>');
        nearme.on('click', function () {
            $(this).addClass('is--active');
            $('#gbStore-search-text').val('');
            StoresApp.searchLocations();
        })
        $('#gbStore-search').append(nearme);
        // console.log(loaded);
        // $('#map-container').addClass("vy-store-locator");
        // $('#stores-list-table').addClass("vy-locator-sidebar");
        // $('#addressInput').removeAttr('placeholder');
        // $('#addressInput').before('<label for="addressInput" class="bmd-label-floating">Buscar una tienda</label>');
        // $('#addressInput').closest('div.input-group').addClass('bmd-form-group');
        // $('button[name="search_locations"]').closest('.form-group').removeClass('form-group');
        // $('button[name="search_locations"]').addClass('vy-cta-btn').removeClass('globo-btn');
        $('.pageSL').bootstrapMaterialDesign({ ripples: false });
        loaded = true;
    }

    var expert_badge_path = 'https://cdn.shopify.com/s/files/1/0253/5034/0711/t/3/assets/Vype-expert-logo-web.png?v=1579852109';

    // This is executed every time a search has been performed by store locator.
    console.log('store locator did a search');
    $('.gbStore-result').each(function () {
        var picture = $(this).data('picture') || $(this).attr('data-picture') || '';
        if (picture) {
            $(this).append('<div class="vype-expert-badge"><img src="' + expert_badge_path + '" /></div>');
            $(this).attr('data-picture', expert_badge_path);
        }
        var name = $(this).find('.gbStore-result-name');
        if (name.text().toLowerCase().indexOf("expert") >= 0) {
            name.before('<div class="expert-pin">EXPERT</div>');
        }

        // var address = $(this).find("#stores-address").text();
        // var city = $(this).find("#stores-city").text();
        // var zipcode = $(this).find("#stores-zipcode").text();
        // var query = address + ', ' + city + ', ' + zipcode;
        // $(this).find('#picture-row').html('<span>Puede encontrar los horarios de apertura y los datos de contacto de esta tienda en Google.</span>');
        // $(this).find('.direction .btn').removeClass('btn-primary').addClass('vy-cta-btn');
        // $(this).find('.direction').append('<a href="https://www.google.com/maps/search/?api=1&query='+query+'" target="_blank" class="btn vy-cta-btn">Buscar en Google</a>');
    })


});


// RETURNS
$(function () {
    var stepBack = 'initial_step';
    var $header = $('.vy-page-header h1');

    function hideWins() {
        $('.returns_nav_wrapper .vy-page-content').hide();
    }

    function showWin(wClass) {
        $('.returns_nav_wrapper .vy-page-content.' + wClass).show();
    }

    $('.dd_actions .btn').on('click', function () {
        var title = $(this).data('title');
        // Display next step
        if ($(this).hasClass('trigger_returns')) {
            // Show returns
            hideWins();
            $header.text(title);
            showWin('returns_step');
        } else if ($(this).hasClass('trigger_back')) {
            // Go back
            hideWins();
            showWin(stepBack);
            $header.text(title);
            stepBack = 'initial_step';
        } else if ($(this).hasClass('trigger_create_returns')) {
            // Go back
            hideWins();
            $header.text(title);
            showWin('create_returns_step');
            stepBack = 'returns_step';
        }
        window.scrollTo(0, 0);
    });



    //Tabs animation for faq page
    $('.nav-tabs-dropdown').each(function (i, elm) {
        $(elm).text($(elm).next('ul').find('li.active a').text());
    });
    $('.nav-tabs-dropdown').on('click', function (e) {
        e.preventDefault();
        $(e.target).toggleClass('open').next('ul').slideToggle();
    });
    $('#nav-tabs-wrapper a[data-toggle="tab"]').on('click', function (e) {
        e.preventDefault();
        $(e.target).closest('ul').hide().prev('a').removeClass('open').text($(this).text());
    });

    //Tabs add class for menu falow a link active effect
    $('.faq_section ul li a').click(function () {
        var id = $(this).attr('href');
        var title = $(this).text();
        $('.faq_block h1').text(title);
        $('.faq_section ul li').removeClass("tab_is_active");
        $(this).parent().addClass('tab_is_active');
        $('.faq_block .tab-pane').removeClass('active show');
        $(id).addClass('active show');
    });


});

// Homepage Carousel

function resizeStaticSlidesInCarousel() {
    var height = $('.vy-section-dynamic-carousel-slide').height();
    $('.vy-section-static-carousel-slide').height(height);
}

$('.vy-brand-hero-carousel').on('init', function () {
    resizeStaticSlidesInCarousel();
});

$('.vy-brand-hero-carousel').slick({
    dots: true, prevArrow: $('.prev'),
    nextArrow: $('.next'),
    autoplay: true,
    autoplaySpeed: 3000,
});

$(window).resize(function () {
    resizeStaticSlidesInCarousel();
});

// smooth scroll to recommendations
$(".vy-cart-recommendation-notice").click(function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
        var scrollDestination = $(".vy-mobile-recommendation").offset().top - 70;
        console.log('mobile');
    } else {
        var scrollDestination = $(".vy-desktop-recommendation").offset().top - 70;
        console.log('desktop');
    }
    console.log(scrollDestination);
    $('html, body').animate({
        scrollTop: scrollDestination
    }, 1000);
});


// AJAX SUBMIT RECOMMENDED PRODUCT TO CART
$('.add_recommended_product_btn').on('click', function (e) {
    e.preventDefault();
    var productId = $(this).data('product-id');
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { items: [{ quantity: 1, id: productId }] },
        complete: function () {
            location.reload();
            return false;
        }
    });
    return false;
});

$('.show-more-recommendations').on('click', function () {
    var wrapper = $(this).closest('.vy-main-cart-recommendation-inner');
    var totalItems = $(wrapper).find('.product-listed-item.vy-d-hidden');
    var items = $(wrapper).find('.product-listed-item.vy-d-hidden:lt(3)');
    items.each(function () {
        $(this).removeClass('vy-d-hidden');
    });

    if (totalItems.length - items.length <= 0) {
        $(this).remove();
    }
});
